import styles from "./ContractStyles";
import timesNewRoman from "../fonts/times-new-roman.ttf";
import timesNewRomanBold from "../fonts/times-new-roman-grassetto.ttf";
import robotoLight from "../fonts/Roboto-Regular.ttf";
import robotoBold from "../fonts/Roboto-Bold.ttf";
import robotoItalic from "../fonts/Roboto-CondensedItalic.ttf";
import robotoThinItalic from "../fonts/Roboto-ThinItalic.ttf";

import { Font } from "@react-pdf/renderer";

Font.register({
  family: "Times New Roman",
  src: timesNewRoman,
});

Font.register({
  family: "Times New Roman Bold",
  src: timesNewRomanBold,
});

Font.register({
  family: "Roboto",
  fonts: [
    { src: robotoLight, fontWeight: "normal" },
    { src: robotoBold, fontWeight: "bold" },
  ],
});
Font.register({
  family: "Roboto-Italic",
  src: robotoThinItalic,
});
Font.register({
  family: "Roboto-BoldItalic",
  fonts: [{ src: robotoItalic, fontWeight: "bold" }],
});

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        paddingLeft: 25,
        paddingTop: 50,
        //paddingLeft:5,
        marginTop: -20,
        marginBottom: -20,
        color: "#000",
      },
      items: [
        {
          type: "text",
          styles: {
            fontSize: 16,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
          },
          content: "TRANSPORT AND SERVICES AGREEMENT FOR YACHTS",
        },
        {
          type: "text",
          styles: {
            fontSize: 10,
            marginTop: 10,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
          },
          content: "N° __agreementUniqueNumber__",
        },
      ],
    },

    {
      type: "view",
      styles: {
        paddingTop: 30,
      },
      items: [
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
              },
              content: "This date ",
            },

            {
              type: "text",
              styles: {
                fontSize: 11,
                marginTop: 5,
                marginBottom: 5,
              },
              content: "__Otheragreementcurrency__ __signDate__",
            },
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
              },
              content: ", and place ",
            },
            {
              type: "text",
              styles: {
                fontSize: 11,
                marginTop: 5,
                marginBottom: 5,
              },
              content: "__signPlace__",
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            width: "50%",
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
                width: "25%",
              },
              content: "BETWEEN : ",
            },
            {
              type: "view",
              styles: { flexDirection: "row", alignItems: "center" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    //marginLeft: 20,
                  },
                  content: "__client__, ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },
                  content: 'Hereinafter the "Client"',
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            width: "50%",
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
                width: "25%",
              },
              content: "AND : ",
            },
            {
              type: "view",
              styles: { flexDirection: "row", alignItems: "center" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    //marginLeft: 40,
                  },
                  content: "__serviceProvider__, ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },
                  content: 'Hereinafter the "Service Provider"',
                },
              ],
            },
          ],
        },
        {
          type: "text",
          styles: {
            fontSize: 9,
            marginTop: 5,
          },

          content: 'Jointly the "Parties"',
        },

        {
          type: "text",
          styles: {
            fontSize: 9,
            marginBottom: 5,
          },

          content:
            "In consideration of the mutual undertakings contained herein, the Parties agree to the following",
        },
      ],
    },
    {
      type: "view",
      styles: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 5,
        marginVertical: 8,
      },
      items: [
        {
          type: "view",
          styles: {
            flex: 1,
            height: 1,
            backgroundColor: "#000",
            marginTop: 8,
          },
          items: [{}],
        },

        {
          type: "text",
          styles: {
            flexDirection: "row",
            justifyContent: "center",
            fontSize: 11,
            fontFamily: "Roboto-Bold",
          },
          content: "INFORMATION ABOUT THE VESSEL",
        },
        {
          type: "view",
          styles: {
            flex: 1,
            height: 1,
            backgroundColor: "#000",
            marginTop: 8,
          },
          items: [{}],
        },
      ],
    },
    {
      type: "view",
      styles: {
        padding: 0,
        marginBottom: 15,
      },
      items: [
        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
          },

          items: [
            {
              type: "view",
              styles: {
                flexDirection: "column",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        marginBottom: 5,
                        fontFamily: "Roboto-Bold",
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Name of Vessel : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        fontFamily: "Roboto",
                        paddingLeft: 30,
                        width: "50%",

                        //marginLeft: 7,
                      },
                      content: "__vesselName__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        //marginRight: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Port of registry : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        fontFamily: "Roboto",
                        //marginLeft: 6,
                        width: "50%",
                        paddingLeft: 30,
                      },
                      content: "__registryPort__",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",
                      },
                      content: "TYPE : ",
                    },

                    {
                      type: "view",
                      specialType: "choice",
                      linkedField: "yachtType",
                      withPadding: true,
                      styles: {
                        flexDirection: "row",
                        //marginLeft: 60,
                        fontSize: 9,
                        width: "70%",
                        paddingLeft: 30,
                      },
                      items: [],
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "column",
                paddingRight: 50,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "IMO number : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        //paddingLeft: 25,
                        width: "50%",
                        fontFamily: "Roboto",
                        paddingLeft: 32,
                      },
                      content: " __imoNumber__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Flag : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        //paddingLeft: 56,
                        fontFamily: "Roboto",
                        width: "50%",
                        paddingLeft: 32,
                      },
                      content: " __flagState__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Overall length : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",
                        //marginLeft: 10,
                        fontFamily: "Roboto",
                        paddingLeft: 32,
                      },
                      content: " __yachtLOADinMeters__m",
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
              },
              content: "DETAILS OF THE PARTIES",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "20%",
                    fontFamily: "Roboto-Bold",
                  },
                  content: "CLIENT : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "100%",
                    //marginLeft: 53,
                  },
                  content: "__client__",
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Address : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "80%",
                    //marginLeft: 49,
                  },
                  content:
                    " __clientAddress1__ __clientAddress2__ __clientAddress3__",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto-Bold",
                    width: "20%",
                  },
                  content: "SERVICE PROVIDER : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "100%",
                    //marginLeft: 3,
                  },
                  content: "__serviceProvider__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Address : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    //marginLeft: 49,
                  },
                  content:
                    " __serviceProviderAddress1__ __serviceProviderAddress2__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registered office address",
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Company ID : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    //marginLeft: 37,
                  },
                  content: " __serviceProviderCompanyId__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registration number and country of incorporation",
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "25%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                    width: "auto",
                  },
                  content: "Insurance : ",
                },
                {
                  type: "view",
                  styles: { width: "25%" },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        paddingLeft: 55,
                        width: "auto",
                      },
                      content: " __serviceProviderInsuranceReference__",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 50,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                    width: "25%",
                  },
                  content: "VAT Number : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "25%",

                    //marginLeft: 21,
                  },
                  content: " __serviceProviderVATReference__",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                justifyContent: "space-between",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        marginBottom: 5,
                        fontFamily: "Roboto-Bold",
                        textTransform: "uppercase",
                        width: "40px",
                      },
                      content: "broker : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        paddingLeft: 64,
                        //width: "175px",
                      },
                      content: "__brokerName__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        //width: "50px",
                        paddingLeft: 27,
                      },
                      content: "MYBA ID : ",
                    },

                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        //width: "auto",
                        paddingLeft: 20,
                        //marginLeft: 21,
                      },
                      content: " __brokerMYBAref__",
                    },
                  ],
                },

                // {
                //   type: "view",
                //   styles: {
                //     flexDirection: "row",
                //     alignItems: "center",
                //     //paddingLeft: 50,
                //     marginRight: 105,
                //     width: "25%",
                //   },
                //   items: [
                //     {
                //       type: "text",
                //       styles: {
                //         fontSize: 8,
                //         marginTop: 5,
                //         marginBottom: 5,
                //         width: "auto",
                //       },
                //       content: "MYBA ID : ",
                //     },

                //     {
                //       type: "text",
                //       styles: {
                //         fontSize: 11,
                //         marginTop: 5,
                //         marginBottom: 5,
                //         width: "auto",
                //         paddingLeft: 20,
                //         //marginLeft: 21,
                //       },
                //       content: " __brokerMYBAref__",
                //     },
                //   ],
                // },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Adresse : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    //marginLeft: 49,
                  },
                  content: " __brokerAddress1__ ",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registered office address",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Company ID : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    //marginLeft: 37,
                  },
                  content: " __brokerCompanyId__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registration number and country of incorporation",
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "25%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                    width: "auto",
                  },
                  content: "Insurance : ",
                },
                {
                  type: "view",
                  styles: { width: "25%" },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        paddingLeft: 55,
                        width: "auto",
                      },
                      content: " __brokerInsurance__",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 50,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "25%",
                    textTransform: "uppercase",
                  },
                  content: "VAT Number : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "25%",

                    //marginLeft: 21,
                  },
                  content: " __brokerVATReference__",
                },
              ],
            },
          ],
        },
        // {
        //   type: "view",
        //   styles: {
        //     flexDirection: "row",
        //     justifyContent: "space-between",
        //   },
        //   items: [
        //     {
        //       type: "view",
        //       styles: {
        //         flexDirection: "row",
        //         alignItems: "center",
        //       },
        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 9,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             fontFamily: "Roboto-Bold",
        //             textTransform: "uppercase",
        //             width: "25%",
        //           },
        //           content: "central agent : ",
        //         },
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 11,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             paddingLeft: 40,

        //             width: "25%",
        //           },
        //           content: "__centralAgent__",
        //         },
        //       ],
        //     },

        //     {
        //       type: "view",
        //       styles: {
        //         flexDirection: "row",
        //         alignItems: "center",
        //         //paddingLeft: 50,
        //         marginRight: 105,
        //         width: "25%",
        //       },
        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 8,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             width: "auto",
        //           },
        //           content: "MYBA ID : ",
        //         },

        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 11,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             width: "auto",
        //             paddingLeft: 20,

        //             //marginLeft: 21,
        //           },
        //           content: " __centralAgentMYBARegistration__",
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto-Bold",
                    textTransform: "uppercase",
                    width: "75px",
                  },
                  content: "central agent : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    paddingLeft: 30,
                    width: "185px",
                  },
                  content: "__centralAgent__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    //width: "50px",
                    paddingLeft: 27,
                  },
                  content: "MYBA ID : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    //width: "auto",
                    paddingLeft: 20,
                    //marginLeft: 21,
                  },
                  content: " __centralAgentMYBARegistration__",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Address : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    // marginLeft: 51,
                  },
                  content: " __centralAgentAddress1__ __centralAgentAddress2__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registered office address",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Company ID : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    //marginLeft: 37,
                  },
                  content: " __centralAgentCompanyId__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registration number and country of incorporation",
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "25%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                    width: "auto",
                  },
                  content: "Insurance : ",
                },
                {
                  type: "view",
                  styles: { width: "25%" },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        paddingLeft: 55,
                        width: "auto",
                      },
                      content: " __centralAgentInsurance__",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 50,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "25%",
                    textTransform: "uppercase",
                  },
                  content: "VAT Number : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    width: "25%",

                    //marginLeft: 21,
                  },
                  content: " __centralAgentVATReference__",
                },
              ],
            },
          ],
        },
        // {
        //   type: "view",
        //   styles: {
        //     flexDirection: "row",
        //     justifyContent: "space-between",
        //   },
        //   items: [
        //     {
        //       type: "view",
        //       styles: {
        //         flexDirection: "row",
        //         alignItems: "center",
        //       },
        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 9,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             fontFamily: "Roboto-Bold",
        //             textTransform: "uppercase",
        //             width: "25%",
        //           },
        //           content: "stakeholder : ",
        //         },
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 11,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             paddingLeft: 40,

        //             width: "25%",
        //           },
        //           content: "__stakeholder__",
        //         },
        //       ],
        //     },
        //     {
        //       type: "view",
        //       styles: {
        //         flexDirection: "row",
        //         alignItems: "center",
        //         //paddingLeft: 50,
        //         marginRight: 105,
        //         width: "25%",
        //       },
        //       items: [
        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 8,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             width: "auto",
        //           },
        //           content: "MYBA ID : ",
        //         },

        //         {
        //           type: "text",
        //           styles: {
        //             fontSize: 11,
        //             marginTop: 5,
        //             marginBottom: 5,
        //             width: "auto",
        //             paddingLeft: 20,

        //             //marginLeft: 21,
        //           },
        //           content: " __stakeHolderMYBAregistration__",
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto-Bold",
                    textTransform: "uppercase",
                    width: "75px",
                  },
                  content: "stakeholder : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    paddingLeft: 30,
                    width: "185px",
                  },
                  content: "__stakeholder__",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    //width: "50px",
                    paddingLeft: 27,
                  },
                  content: "MYBA ID : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    //width: "auto",
                    paddingLeft: 20,
                    //marginLeft: 21,
                  },
                  content: " __stakeHolderMYBAregistration__",
                },
              ],
            },
          ],
        },

        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Address : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    //marginLeft: 51,
                    width: "80%",
                  },
                  content: " __stakeholderAddress1__ __stakeholderAddress2__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registered office address",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    textTransform: "uppercase",
                    width: "20%",
                  },
                  content: "Company ID : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    width: "80%",
                    //marginLeft: 39,
                  },
                  content: " __stakeholderCompanyId__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 6,
              },
              content: "Registration number and country of incorporation",
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                justifyContent: "space-between",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "25%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "auto",
                      },
                      content: "Insurance : ",
                    },
                    {
                      type: "view",
                      styles: { width: "25%" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginTop: 5,
                            marginBottom: 5,
                            paddingLeft: 55,
                            width: "auto",
                          },
                          content: " __stakeHolderInsuranceReference__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    paddingLeft: 50,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "25%",
                        textTransform: "uppercase",
                      },
                      content: "VAT Number : ",
                    },

                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "25%",

                        //marginLeft: 21,
                      },
                      content: " __stakeHolderVATreference__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },

              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "20%",
                      },
                      content: "Financial Guarantee : ",
                    },

                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "80%",
                      },
                      content: " __stakeHolderFinancialGuarantee__",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "view",

      // styles: {
      //   position: "absolute",
      //   bottom: -40,
      //   left: 0,
      //   display: "flex",
      //   flexDirection: "row",
      // },
      styles: {
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        display: "flex",
        flexDirection: "row",
      },

      items: [
        {
          type: "view",

          styles: { width: "30%" },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
              },

              content: "PLEASE INITIAL",
            },
          ],
        },
        {
          type: "view",

          styles: { width: "100%", flexDirection: "row" },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
              },

              content: "SERVICE PROVIDER ______________",
            },
            {
              type: "text",
              styles: {
                fontSize: 9,
                marginTop: 5,
                marginBottom: 5,
                marginLeft: 50,
              },

              content: "CLIENT _______________",
            },
          ],
        },
      ],
    },
    {
      type: "view",
      items: [
        {
          type: "view",
          attrs: { break: true },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                marginTop: 30,
                marginBottom: 5,
                //marginHorizontal: 5,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flex: 1,
                    height: 1,
                    backgroundColor: "#000",
                    marginTop: 8,
                  },
                  items: [{}],
                },

                {
                  type: "text",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "center",
                    fontSize: 11,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "CRUISE PARTICULARS",
                },
                {
                  type: "view",
                  styles: {
                    flex: 1,
                    height: 1,
                    backgroundColor: "#000",
                    marginTop: 8,
                  },
                  items: [{}],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: { flexDirection: "column", flex: 1 },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        fontFamily: "Roboto-Bold",
                        width: "50%",
                      },
                      content: "From : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "Port of embarkation : ",
                    },

                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "auto",
                      },
                      content: "Port of delivery : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "auto",
                      },
                      content: "CRUISING AREA : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "auto",
                        textTransform: "uppercase",
                      },
                      content: "Total hours of navigation : ",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: { flexDirection: "column", flex: 1 },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "__cruiseStartDate__ __cruiseStartTime__",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginBottom: 5,
                      },
                      content: " __embarkationPort__",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 2,
                        marginBottom: 5,
                        width: "auto",
                      },
                      content: " __deliveryPort__",
                    },
                    {
                      type: "view",
                      styles: {
                        flex: 1,
                        width: "100%",
                        flexDirection: "row",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginBottom: 5,
                            position: "absolute",
                          },
                          content: " __cruisingArea__",
                        },
                      ],
                    },
                    {
                      type: "view",
                      styles: {
                        fontSize: 8,
                        width: "auto",
                        textTransform: "uppercase",
                        flexDirection: "row",
                        marginBottom: 5,
                        marginTop: 5,
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: { fontSize: 11 },
                          content: "__totalHoursOfNavigation__ ",
                        },
                        {
                          type: "text",
                          styles: {
                            fontSize: 6,
                          },
                          content: "(vessel underway)",
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: { flexDirection: "column", flex: 1 },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        fontFamily: "Roboto-Bold",
                        width: "50%",
                      },
                      content: "TO : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "Port of disembarkation : ",
                    },

                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "auto",
                      },
                      content: "Port of redelivery : ",
                    },
                    {
                      type: "view",
                      styles: {
                        marginTop: 5,
                        marginBottom: 15,
                      },
                      items: [{}],
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "auto",
                        textTransform: "uppercase",
                      },
                      content: "Scheduled itinerary : ",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: { flexDirection: "column", flex: 1 },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "__cruiseEndDate__ __cruiseEndTime__",
                    },
                    {
                      type: "view",
                      styles: {
                        flex: 1,
                        width: "100%",
                        flexDirection: "row",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginBottom: 5,
                            position: "absolute",
                          },
                          content: " __disembarkationPort__",
                        },
                      ],
                    },
                    // {
                    //   type: "text",
                    //   styles: {
                    //     fontSize: 11,
                    //     marginBottom: 5,
                    //     textTransform: "uppercase",
                    //     position: "absolute"
                    //   },
                    //   content: " __disembarkationPort__",
                    // },

                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 2,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "25%",
                      },
                      content: " __redeliveryPort__",
                    },
                    {
                      type: "view",
                      styles: {
                        marginTop: 5,
                        marginBottom: 10,
                      },
                      items: [{}],
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "auto",
                      },

                      content: "Cf. Appendix I",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 5,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    alignItems: "center",
                    width: "50%",
                    textTransform: "uppercase",
                  },
                  content: "Maximum number of Passengers with staterooms : ",
                  items: [
                    {
                      type: "text",
                      styles: { fontSize: 11 },
                      content: "(__paxWithCabinNb__)",
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    alignItems: "center",
                    width: "50%",
                    textTransform: "uppercase",
                    paddingLeft: 10,
                  },
                  content: "Day Passengers on board ",
                  items: [
                    {
                      type: "text",
                      styles: { fontSize: 11 },
                      content: "(__dayPaxWithoutCabinNb__)",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              specialType: "choice",
              linkedField: "fiscalCategoryOfCruise",
              withPadding: true,
              styles: {
                textTransform: "uppercase",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 5,
                fontSize: 8,
              },
              items: [],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
                textTransform: "uppercase",
              },
              content: "Service package price (clauses 12 to 16)",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          styles: { flexDirection: "column" },
          items: [
            {
              type: "view",
              styles: { flexDirection: "row", alignItems: "center" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                  },
                  content: "Agreement currency : ",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 5,
                    marginLeft: 26,
                  },
                  content: "__currencyMain__ ",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                  },
                  content:
                    "Total price for Service Package - Voyage, Services and Accommodation : ",
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 5,
                    marginBottom: 5,
                    justifyContent: "flex-end",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "__totalPriceExclVat__ __currencyMain__ ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "EXC-VAT",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "VAT rate : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        marginLeft: 82,
                      },
                      content: "__vatRate__ %",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "VAT amount : ",
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginTop: 5,
                            marginBottom: 5,
                            marginRight: 34,
                          },
                          content: "__vatAmount__ __currencyMain__",
                        },
                        {
                          type: "view",
                          styles: { width: "20%" },
                          items: [{}],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                    textTransform: "uppercase",
                  },
                  content:
                    "Total price for Service Package - Voyage, Services and Accommodation : ",
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 5,
                    marginBottom: 5,
                    justifyContent: "flex-end",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "__totalPriceIncVat__ __currencyMain__ ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "INC-VAT",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [{}],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "Advance provisioning allowance : ",
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginTop: 5,
                            marginBottom: 5,
                            marginRight: 34,
                          },
                          content: "__advanceProvisioning__ __currencyMain__",
                        },
                        {
                          type: "view",
                          styles: { width: "20%" },
                          items: [{}],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [{}],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                      },
                      content: "Security deposit : ",
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginTop: 5,
                            marginBottom: 5,
                            marginRight: 34,
                          },
                          content: "__securityDeposit__ __currencyMain__",
                        },
                        {
                          type: "view",
                          styles: { width: "20%" },
                          items: [{}],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [{}],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        fontFamily: "Roboto-Bold",
                      },
                      content: "Total amount of payment : ",
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontSize: 11,
                            marginTop: 5,
                            marginBottom: 5,
                            marginRight: 34,
                            fontFamily: "Roboto-Bold",
                          },
                          content: "__totalAmountPayment__ __currencyMain__",
                        },
                        {
                          type: "view",
                          styles: { width: "20%" },
                          items: [{}],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
              },
              content: "TERMS OF PAYMENT",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },

        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "First instalment : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",

                        //marginLeft: 32,
                      },
                      content: "__firstInstalment__ __currencyMain__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Due date : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",

                        //marginLeft: 20,
                      },
                      content: "__firstInstalmentDate__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              name: "secondInstalmentBlock",
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Second instalment : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",
                        //marginLeft: 22,
                      },
                      content: "__secondInstalment__ __currencyMain__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Due date : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",
                        //marginLeft: 20,
                      },
                      content: "__secondInstalmentDate__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              name: "thirdInstalmentBlock",
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Third instalment : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",

                        //marginLeft: 30,
                      },
                      content: "__thirdInstalment__ __currencyMain__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "50%",
                      },
                      content: "Due date : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        width: "50%",

                        //marginLeft: 20,
                      },
                      content: "__thirdInstalmentDate__",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
              },
              content: "BANK TRANSFER DETAILS",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "30%",
                      },
                      content: "Bank Name : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        //marginLeft: 60,
                        width: "100%",
                        paddingLeft: 5,
                      },
                      content: "__bankDesignation__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "30%",
                      },
                      content: "Bank Address : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        //marginLeft: 60,
                        width: "100%",
                        paddingLeft: 5,
                      },
                      content: "__bankAddress1__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                        textTransform: "uppercase",
                        width: "30%",
                      },
                      content: "Account name : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        //marginLeft: 60,
                        width: "100%",
                        paddingLeft: 5,
                      },
                      content: "__bankAccountName__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        maxrginTop: 5,
                        marginBottom: 5,
                        // width: "30%",
                      },
                      content: "IBAN : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        // width: "60%",
                        //paddingLeft: 0,
                        marginLeft: 60,
                      },
                      content: "__bankIban__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                    paddingLeft: 40,
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 8,
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "BIC/SWIFT : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginTop: 5,
                        marginBottom: 5,
                        marginLeft: 5,
                      },
                      content: "__bankBicSwift__",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
              },
              content: "LANGUAGE",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          items: [
            {
              type: "text",
              styles: {
                fontSize: 11,
                marginTop: 5,
                marginBottom: 5,
              },
              content:
                "This Agreement is provided in English, with a non-official version in French being available. In case of a dispute regarding the interpretation of Agreement, the sole English version, included its appendices, is regarded as the legal reference of Agreement.",
            },
          ],
        },

        {
          type: "view",

          styles: {
            position: "absolute",
            bottom: -120,
            left: 0,
            display: "flex",
            flexDirection: "row",
          },

          items: [
            {
              type: "view",

              styles: { width: "30%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "PLEASE INITIAL",
                },
              ],
            },
            {
              type: "view",

              styles: { width: "100%", flexDirection: "row" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "SERVICE PROVIDER ______________",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    marginLeft: 50,
                  },

                  content: "CLIENT _______________",
                },
              ],
            },
          ],
        },
      ],
    },

    {
      type: "view",
      attrs: { break: true },
      styles: { paddingTop: 30, marginBottom: 70 },
      items: [
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
            marginVertical: 8,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 11,
                fontFamily: "Roboto-Bold",
              },
              content: "SPECIAL CONDITIONS",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "text",
          styles: {
            fontSize: 9,
            marginTop: 5,
            marginBottom: 5,
          },
          content:
            "The scope of services is set out in Appendix II and in the special conditions below.",
        },

        {
          type: "text",
          styles: {
            fontSize: 9,
            marginBottom: 5,
          },
          content:
            "The price for the services listed below is included in the above Price of the Service Package.",
        },
        {
          type: "view",

          styles: {
            height: "80vh",
            overflow: "hidden",
            border: "1pt solid #000000",
            padding: 10,
          },
          items: [
            {
              type: "text",
              styles: {
                fontSize: 10,
                marginTop: 5,
                marginBottom: 5,
              },
              content: "__specialConditions__",
            },
          ],
        },
        {
          type: "view",

          styles: {
            position: "absolute",
            bottom: -40,
            left: 0,
            display: "flex",
            flexDirection: "row",
          },

          items: [
            {
              type: "view",

              styles: { width: "30%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "PLEASE INITIAL",
                },
              ],
            },
            {
              type: "view",

              styles: { width: "100%", flexDirection: "row" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "SERVICE PROVIDER ______________",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    marginLeft: 50,
                  },

                  content: "CLIENT _______________",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "view",
      styles: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 5,
        paddingTop: 30,
        marginHorizontal: 10,
      },
      items: [
        {
          type: "view",
          styles: {
            flex: 1,
            height: 1,
            backgroundColor: "#000",
            marginTop: 8,
          },
          items: [{}],
        },

        {
          type: "text",
          styles: {
            flexDirection: "row",
            justifyContent: "center",
            fontSize: 11,
            fontFamily: "Roboto-Bold",
          },
          content: "SIGNATURES",
        },
        {
          type: "view",
          styles: {
            flex: 1,
            height: 1,
            backgroundColor: "#000",
            marginTop: 8,
          },
          items: [{}],
        },
      ],
    },
    {
      type: "view",
      attrs: {
        break: true,
      },
      items: [
        {
          type: "text",
          styles: {
            fontSize: 9,
            marginTop: 5,
            marginBottom: 5,
          },
          content:
            "The Service Provider and the Client hereby agree that the attached Appendices I (itinerary and Passenger list), II (vessel and scope of services), III (General Sales Conditions, clauses 1 to 29 inclusive), and any/all Special Conditions set out above are an integral part of this Agreement. This Agreement is binding upon signature by the Parties. Signatures provided by fax/email, or in a PDF document sent via email, constitute a legal and enforceable obligation for said signatory having the same force and effect as if this Agreement were an original, irrespective of the original jurisdiction of the Agreement.",
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            border: "1pt solid #000000",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "50%",
                padding: 5,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginBottom: 5,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "ADDITIONAL INSURANCE",
                },

                {
                  type: "view",
                  specialType: "choice",
                  linkedField: "insuranceOrNo",
                  styles: { fontSize: 9 },
                  items: [
                    {
                      type: "text",
                      styles: {
                        marginTop: 5,
                        marginBottom: 5,
                      },
                      content: "__insuranceOrNo__",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "center",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        paddingLeft: 8,
                        paddingRight: 8,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "additionalInsuranceLuggage",
                          styles: {
                            ...styles.checkbox,
                            borderRadius: 0,
                            width: "5pt",
                            height: "5pt",
                            marginTop: 3,
                            backgroundColor:
                              "__additionalInsuranceLuggage__" === true ||
                              "__additionalInsuranceLuggage__" === "true"
                                ? "#000"
                                : "transparent",
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 8,
                            marginBottom: 5,
                            paddingTop: "3pt",
                            textTransform: "uppercase",
                          },
                          content: "__additionalInsuranceLuggage__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        paddingLeft: 8,
                        paddingRight: 8,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "additionalInsuranceAssistance",
                          styles: {
                            ...styles.checkbox,
                            borderRadius: 0,
                            width: "5pt",
                            height: "5pt",
                            marginTop: 3,
                            backgroundColor:
                              "__additionalInsuranceAssistance__" === "true"
                                ? "#00000000"
                                : "transparent",
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 8,
                            marginBottom: 5,
                            paddingTop: "3pt",
                            textTransform: "uppercase",
                          },
                          content: "__additionalInsuranceAssistance__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        paddingLeft: 8,
                        paddingRight: 8,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "additionalInsuranceCancellation",
                          styles: {
                            ...styles.checkbox,
                            borderRadius: 0,
                            width: "5pt",
                            height: "5pt",
                            marginTop: 3,
                            backgroundColor:
                              "__additionalInsuranceCancellation__" === "true"
                                ? "#00000000"
                                : "transparent",
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 8,
                            marginBottom: 5,
                            paddingTop: "3pt",
                            textTransform: "uppercase",
                          },
                          content: "__additionalInsuranceCancellation__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    ...styles.checkboxWrapper,
                    borderTop: "1pt solid #000000",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkbox,
                        borderRadius: 0,
                        marginTop: 10,
                        width: "10pt",
                        height: "10pt",
                      },
                      items: [],
                    },

                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginBottom: 5,
                        marginTop: 10,
                      },
                      content:
                        "I hereby declare that I have read, understood and agree to all the terms of this Agreement, its conditions and appendices",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        fontFamily: "Roboto-Bold",
                      },
                      content: "CLIENT : ",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 11,
                        marginBottom: 5,
                        fontFamily: "Roboto",
                      },
                      content: "__client__",
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 5,
                  },
                  content: "DATE : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 6,
                    marginTop: 20,
                    marginBottom: 5,
                  },
                  content:
                    'Represented by "name, capacity of signatory, full address", duly authorised as the Client\'s representative for the signature of this Agreement',
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "SIGNATURE : ____",
                },

                {
                  type: "view",
                  styles: {
                    height: "50pt",
                  },
                  items: [],
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "50%",
                borderLeft: "1pt solid #000000",
                paddingTop: 153,
                paddingBottom: 5,
                paddingLeft: 5,
                paddingRight: 5,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "SERVICE PROVIDER : ",
                    },
                  ],
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 11,
                  },
                  content: "__serviceProvider__",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 12,
                    marginBottom: 5,
                  },
                  content: "DATE : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 6,
                    marginTop: 0,
                    marginBottom: 5,
                    paddingTop: 20,
                  },
                  content:
                    'Represented by "name, capacity of signatory, full address", duly authorised as the Service Provider\'s representative for signature of this Agreement',
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "SIGNATURE : ____",
                },

                {
                  type: "view",
                  styles: {
                    height: "50pt",
                  },
                  items: [],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: "10pt",
            border: "1pt solid #000000",
            flexDirection: "row",
          },
          items: [
            {
              type: "view",
              styles: {
                width: "33%",
                borderRight: "1pt solid #000000",
                padding: 5,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        fontFamily: "Roboto-Bold",
                        textTransform: "uppercase",
                      },
                      content: "broker : ",
                    },
                  ],
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 50,
                  },
                  content: "__brokerName__",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 15,
                    fontFamily: "Roboto",
                  },
                  content: "DATE : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 6,
                    marginTop: 5,
                    marginBottom: 5,
                    paddingBottom: "50pt",
                  },
                  content:
                    'Represented by "name, capacity of signatory, full address", duly authorised as the Broker\'s representative for signature of this Agreement',
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "33%",
                borderRight: "1pt solid #000000",
                padding: 5,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        fontFamily: "Roboto-Bold",
                        textTransform: "uppercase",
                      },
                      content: "central agent : ",
                    },
                  ],
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 50,
                  },
                  content: "__centralAgent__",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 15,
                    fontFamily: "Roboto",
                  },
                  content: "DATE : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 6,
                    marginTop: 5,
                    marginBottom: 5,
                    paddingBottom: "50pt",
                  },
                  content:
                    'Represented by "name, capacity of signatory, full address", duly authorised as the Central agent\'s representative for signature of this Agreement',
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "33%",
                padding: 5,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontSize: 9,
                        marginTop: 5,
                        fontFamily: "Roboto-Bold",
                        textTransform: "uppercase",
                      },
                      content: "stakeholder : ",
                    },
                  ],
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 11,
                    marginTop: 5,
                    marginBottom: 50,
                  },
                  content: "__stakeholder__",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 8,
                    marginTop: 5,
                    marginBottom: 15,
                    fontFamily: "Roboto",
                  },
                  content: "DATE : ",
                },

                {
                  type: "text",
                  styles: {
                    fontSize: 6,
                    marginTop: 5,
                    marginBottom: 5,
                    paddingBottom: "50pt",
                  },
                  content:
                    'Represented by "name, capacity of signatory, full address", duly authorised as the Stakeholder\'s representative for signature of this Agreement',
                },
              ],
            },
          ],
        },
        {
          type: "view",

          styles: {
            position: "absolute",
            bottom: -150,
            left: 0,
            display: "flex",
            flexDirection: "row",
          },

          items: [
            {
              type: "view",

              styles: { width: "30%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "PLEASE INITIAL",
                },
              ],
            },
            {
              type: "view",

              styles: { width: "100%", flexDirection: "row" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                  },

                  content: "SERVICE PROVIDER ______________",
                },
                {
                  type: "text",
                  styles: {
                    fontSize: 9,
                    marginTop: 5,
                    marginBottom: 5,
                    marginLeft: 50,
                  },

                  content: "CLIENT _______________",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
